import React from 'react';
import SolutionImg from '../../assets/images/Image.png';

function TermsUse() {
    return (
        <div className="container privacyPolicy mb-5">
            <div className="solution__hero">
                <div className='container d-flex justify-content-between'>
                    <div className="solution__hero-text d-flex justify-content-start align-items-center">
                        <h1>Conditions d'utilisation </h1>
                    </div>
                    <div className="solution__hero-img">
                        <img src={SolutionImg} alt="image data 360 degree" />
                    </div>
                </div>
            </div>

            <div className='privacyPolicy__title p-4 d-flex justify-content-center align-items-center'>
                <h1>Conditions d'utilisation </h1>
            </div>

            <div className='PrivacyPolicy__content display-flex-center flex-column gap-3'>
                <div className='mb-3'>
                    <span className=''>Dernière mise à jour : Avril 2025</span>
                </div>

                <div className='PrivacyPolicy__content-text text-justify'>
                    <p > Bienvenue sur le site de Data360degree.</p>
                    <p> En tant qu’entreprise spécialisée en recherche marketing, études de données et conseil stratégique, Data360degree attache  <br /> une grande importance à la protection de vos informations personnelles ainsi qu’à la transparence de nos pratiques. <br /> Nous nous engageons  à traiter les données de nos visiteurs, partenaires et clients avec le plus grand soin, dans le respect des <br /> lois en vigueur.</p> 
                    <p>Ces conditions d'utilisation visent à vous informer clairement sur les données que nous <br /> collectons,
                        les raisons de cette collecte, la manière dont elles sont utilisées, et les droits dont vous disposez.
                    </p>
                    <p>Nous vous remercions pour votre confiance et restons à votre disposition pour toute question ou demande complémentaire. </p>
                    <p>— L’équipe Data360degree</p>
                </div>

                <div>
                    <h2>Acceptation des conditions</h2>
                </div>

                <div>
                    {/* <h3>1. Pour les visiteurs du site :</h3> */}
                </div>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>En accédant au site web de Data360degree (https://data360degree.net), vous acceptez les présentes conditions d'utilisation. Si vous <br /> n'acceptez pas ces conditions, veuillez ne pas utiliser ce site.</li>

                </ul>

                <div>
                    <h2>Accès au site</h2>
                </div>

                <div>
                    {/* <h3>1. Pour les visiteurs du site :</h3> */}
                </div>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Nous nous efforçons d'assurer un accès continu à notre site, mais nous ne garantissons pas qu’il sera disponible à tout moment. <br /> Nous nous réservons le droit de modifier ou d’interrompre tout ou partie du site sans préavis.</li>

                </ul>

                <div>
                    <h2>Utilisation autorisée</h2>
                </div>

                <div>
                    {/* <h3>1. Pour les visiteurs du site :</h3> */}
                </div>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Vous vous engagez à utiliser ce site conformément à la loi et à ne pas porter atteinte aux droits de Data360degree ou de tiers. Toute <br />utilisation abusive ou frauduleuse du site est strictement interdite.</li>

                </ul>

                <div>
                    <h2>Propriété intellectuelle</h2>
                </div>

                <div>
                    {/* <h3>1. Pour les visiteurs du site :</h3> */}
                </div>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Tous les contenus présents sur le site (textes, logos, images, documents, etc.) sont la propriété exclusive de Data360degree <br />, sauf mention contraire. Toute reproduction ou utilisation non autorisée est interdite.</li>

                </ul>

                <div>
                    <h2>Données personnelles</h2>
                </div>

                <div>
                    {/* <h3>1. Pour les visiteurs du site :</h3> */}
                </div>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>L’utilisation de ce site implique la collecte de certaines données personnelles. Veuillez consulter notre Politique de confidentialité pour <br /> en savoir plus sur la façon dont nous collectons et utilisons ces données.</li>

                </ul>

                <div>
                    <h2>Liens externes</h2>
                </div>

                <div>
                    {/* <h3>1. Pour les visiteurs du site :</h3> */}
                </div>
                {/* Une liste de données ordonées */}
                <ul>
                    <li>Le site peut contenir des liens vers d'autres sites. Data360degree n'est pas responsable du contenu ou des politiques de confidentialité de <br /> ces sites tiers.</li>

                </ul>
            </div>
        </div>
    )
}

export default TermsUse;